import { Image } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // or HistoryIcon, LoginIcon, etc.
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import EventNoteIcon from "@mui/icons-material/EventNote";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import SdStorageOutlinedIcon from "@mui/icons-material/SdStorageOutlined";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import subscription from "../";
import IconLib from "../components/IconLib";
const fileManager = [
  {
    name: "Dashboard",
    // icon: <DashboardCustomizeIcon fontSize="small" />,
    icon: IconLib.dashboard,
    to: "/",
  },
  {
    name: "Subscription",
    icon: IconLib.subscription,
    to: "/subscription",
  },
  {
    name: "User",
    icon: IconLib.users,
    to: "/users",
  },
  {
    name: "Location",
    icon: IconLib.location,
    to: "/location",
  },

  // {
  //   name: "IP Address",
  //   icon: IconLib.ipaddress,
  //   to: "/ip-address",
  // },

  // {
  //   name: "Transaction",
  //   icon: IconLib.transaction,
  //   to: "/transaction",
  // },

  {
    name: "Storage",
    icon: IconLib.storage,
    to: "/storage",
  },
  {
    name: "Products",
    icon: IconLib.Products,
    to: "/products",
  },
  {
    name: "Activity",
    icon: IconLib.loginactivity,
    to: "/activity",
  },
  {
    name: "Engagement",
    icon: IconLib.users,
    to: "/engagement",
  },
  {
    name: "Content",
    icon: IconLib.transaction,
    to: "/content",
  },
  // {
  //   name: "Registration",
  //   icon: <AppRegistrationIcon fontSize="small" />,
  //   to: "/registration",
  // },

  // {
  //   name: "Country",
  //   icon: <LocationOnIcon fontSize="small" />,
  //   to: "/Country",
  // },

  // {
  //   name: "Revenue",
  //   icon: <AttachMoneyIcon fontSize="small" />,
  //   to: "/revenue",
  // },

  // {
  //   name: "My Files",
  //   icon: <FolderOutlinedIcon fontSize="small" />,
  //   to: "/files",
  // },
  // {
  //   name: "Recent",
  //   icon: <AccessTimeOutlinedIcon fontSize="small" />,
  //   to: "/recent",
  // },
  // {
  //   name: "Favorite",
  //   icon: <GradeOutlinedIcon fontSize="small" />,
  //   to: "/favorite",
  // },
  // {
  //   name: "Trash",
  //   icon: <DeleteOutlinedIcon fontSize="small" />,
  //   to: "/trash",
  // },
];

const sharedFile = [
  // {
  //   name: "Shared with me",
  //   icon: <PeopleIcon fontSize="small" />,
  //   to: "/shared-with-me",
  // },
  // {
  //   name: "Shared by me",
  //   icon: <PersonIcon fontSize="small" />,
  //   to: "/shared-by-me",
  // },
];

export { fileManager, sharedFile };
